var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { update } from "@tweenjs/tween.js";
import config from "@/config";
import SplashGame from "@/lib/SplashGame";
import UtilsParams from "./lib/utils/params";
var data = {};
var Boot = /** @class */ (function (_super) {
    __extends(Boot, _super);
    function Boot() {
        return _super.call(this, { key: "Boot" }) || this;
    }
    Boot.prototype.init = function () {
        // init sdk
        SplashGame.i18nHandler.getInstance().load(UtilsParams.get("lang"));
        SplashGame.EventHandler.getInstance().load();
        SplashGame.PauseHandler.getInstance().load();
        SplashGame.ResizeHandler.getInstance().load(config.phaser.scale);
        SplashGame.UserHandler.getInstance().load();
        SplashGame.AdHandler.getInstance().load();
        // init params
        var user = SplashGame.UserHandler.getInstance().user;
        this.params = {
            user: user,
        };
    };
    Boot.prototype.create = function () {
        this.scene.start("SplashScene", this.params);
    };
    return Boot;
}(Phaser.Scene));
config.phaser.scene.unshift(Boot);
var Game = new Phaser.Game(config.phaser);
Game.events.on("step", function (time, delta) {
    update();
});
export default Game;
